import { useCallback, useState } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { IPositionWithDrawing } from 'src/generated-types'
import { IOlexMatchPreview } from 'src/generated-types/olex-match'
import { IProjectInfo } from 'src/generated-types/project'
import { OlexRequest } from './olexMatch.action'
import { fetchProjectPositions, useRevisionOlexUpload } from './useRevisionOlexUpload'

// The project setup's side of an Olex file laid over a draft: the matched file goes to the Configure Positions below,
// which applies it, and the form then takes over the draft's positions and counts so it does not save older ones over it.
export const useSetupOlexRevision = (
  project: IProjectInfo,
  form: UseFormReturn<any>,
  setPositions: (positions: IPositionWithDrawing[]) => void,
) => {
  const [olexRequest, setOlexRequest] = useState<OlexRequest>()
  const onBeforeUpload = useRevisionOlexUpload(project, setOlexRequest)
  const onApplied = useCallback(
    async (preview: IOlexMatchPreview) => {
      setPositions(await fetchProjectPositions(project))
      form.setValue('noOfCages', preview.cages)
      form.setValue('noOfRows', preview.rows)
      form.setValue('noOfPens', preview.pens)
    },
    [form, project, setPositions],
  )
  return { olexRequest, onBeforeUpload, onApplied }
}
